import { ComponentType, lazy } from "react";

function lazyScreen<T extends Record<string, unknown>>(
  importer: () => Promise<T>,
  name: keyof T & string
) {
  return lazy(() =>
    importer().then((module) => ({ default: module[name] as ComponentType<unknown> }))
  );
}

// Auth & home (also exported from featureRoutes for public routes)
export const Home = lazyScreen(() => import("../screens/home"), "Home");
export const Products = lazyScreen(() => import("../screens/products"), "Products");
export const AuthContainer = lazyScreen(() => import("../screens/auth"), "AuthContainer");
export const RegisterContainer = lazyScreen(
  () => import("../screens/auth"),
  "RegisterContainer"
);

export const ActionList = lazyScreen(() => import("../screens/actionList"), "ActionList");
export const AnomaliesObjectDetails = lazyScreen(
  () => import("../screens/anomalies"),
  "AnomaliesObjectDetails"
);
export const AnomaliesType = lazyScreen(() => import("../screens/anomalies"), "AnomaliesType");
export const SelectAnomaliesType = lazyScreen(
  () => import("../screens/anomalies"),
  "SelectAnomaliesType"
);
export const CallCenter = lazyScreen(() => import("../screens/callCenter"), "CallCenter");
export const Camera = lazyScreen(() => import("../screens/camera"), "Camera");
export const ChecksScreen = lazyScreen(() => import("../screens/checks"), "ChecksScreen");
export const CheckTypesScreen = lazyScreen(
  () => import("../screens/checkTypes"),
  "CheckTypesScreen"
);
export const Courier = lazyScreen(() => import("../screens/courier"), "Courier");
export const Vacancies = lazyScreen(() => import("../screens/courier"), "Vacancies");
export const VacanciesCreate = lazyScreen(
  () => import("../screens/courier"),
  "VacanciesCreate"
);
export const VacanciesMap = lazyScreen(() => import("../screens/courier"), "VacanciesMap");
export const EmptyPage = lazyScreen(() => import("../screens/emptyPage"), "EmptyPage");
export const Evotor = lazyScreen(() => import("../screens/evotor"), "Evotor");
export const Orders = lazyScreen(() => import("../screens/evotor"), "Orders");
export const ExternalCamera = lazyScreen(
  () => import("../screens/externalСamera"),
  "ExternalCamera"
);
export const ExternalCameraType = lazyScreen(
  () => import("../screens/externalСamera"),
  "ExternalCameraType"
);
export const StreamPage = lazyScreen(() => import("../screens/externalСamera"), "StreamPage");
export const SelectCamera = lazyScreen(
  () => import("../screens/externalСamera/SelectCamera"),
  "SelectCamera"
);
export const Financial = lazyScreen(() => import("../screens/financial"), "Financial");
export const FinancialCacheflow = lazyScreen(
  () => import("../screens/financial"),
  "FinancialCacheflow"
);
export const FinancialCacheflowCommon = lazyScreen(
  () => import("../screens/financial"),
  "FinancialCacheflowCommon"
);
export const FinancialLeftovers = lazyScreen(
  () => import("../screens/financial"),
  "FinancialLeftovers"
);
export const FinancialCaheflowDetails = lazyScreen(
  () => import("../screens/financial/FinancialCaheflowDetails"),
  "FinancialCaheflowDetails"
);
export const FinancialPL = lazyScreen(() => import("../screens/financial/FinancialPL"), "FinancialPL");
export const FinancialPLDetails = lazyScreen(
  () => import("../screens/financial/FinancialPLDetails"),
  "FinancialPLDetails"
);
export const FinOrdersCreate = lazyScreen(() => import("../screens/finOrders"), "FinOrdersCreate");
export const FinOrdersList = lazyScreen(() => import("../screens/finOrders"), "FinOrdersList");
export const FinOrdersMenu = lazyScreen(() => import("../screens/finOrders"), "FinOrdersMenu");
export const Anomalies = lazyScreen(() => import("../screens/gpt"), "Anomalies");
export const AiAssistantPage = lazyScreen(
  () => import("../screens/aiAssistant"),
  "AiAssistantPage"
);
export const Forecast = lazyScreen(() => import("../screens/gpt"), "Forecast");
export const GptChat = lazyScreen(() => import("../screens/gpt"), "GptChat");
export const GptMain = lazyScreen(() => import("../screens/gpt"), "GptMain");
export const InfoType = lazyScreen(() => import("../screens/info"), "InfoType");
export const InfoView = lazyScreen(() => import("../screens/info"), "InfoView");
export const Inventory = lazyScreen(() => import("../screens/inventory"), "Inventory");
export const InventoryCheckForm = lazyScreen(
  () => import("../screens/inventory"),
  "InventoryCheckForm"
);
export const InventoryCreateForm = lazyScreen(
  () => import("../screens/inventory"),
  "InventoryCreateForm"
);
export const InventoryListPage = lazyScreen(
  () => import("../screens/inventory"),
  "InventoryListPage"
);
export const ScannerPage = lazyScreen(() => import("../screens/inventory"), "ScannerPage");
export const InventoryViewCard = lazyScreen(
  () => import("../screens/inventory/InventoryViewCard"),
  "InventoryViewCard"
);
export const ListSurveys = lazyScreen(() => import("../screens/listSurveys"), "ListSurveys");
export const Loyalty = lazyScreen(() => import("../screens/loyalty"), "Loyalty");
export const LoyaltyClient = lazyScreen(() => import("../screens/loyalty"), "LoyaltyClient");
export const LoyaltyClientInfo = lazyScreen(
  () => import("../screens/loyalty"),
  "LoyaltyClientInfo"
);
export const LoyaltyClientReport = lazyScreen(
  () => import("../screens/loyalty"),
  "LoyaltyClientReport"
);
export const LoyaltyHistory = lazyScreen(() => import("../screens/loyalty"), "LoyaltyHistory");
export const LoyaltyReport = lazyScreen(() => import("../screens/loyalty"), "LoyaltyReport");
export const Marketing = lazyScreen(() => import("../screens/marketing"), "Marketing");

export const MonitorAll = lazyScreen(
  () => import("../screens/monitoring/MonitorAll"),
  "MonitorAll"
);
export const Monitoring = lazyScreen(
  () => import("../screens/monitoring/Monitoring"),
  "Monitoring"
);
export const MonitoringActions = lazyScreen(
  () => import("../screens/monitoring/MonitoringActions"),
  "MonitoringActions"
);
export const MonitoringByCourier = lazyScreen(
  () => import("../screens/monitoring/MonitoringByCourier"),
  "MonitoringByCourier"
);
export const MonitoringByRange = lazyScreen(
  () => import("../screens/monitoring/MonitoringByRange"),
  "MonitoringByRange"
);
export const MonitoringBySource = lazyScreen(
  () => import("../screens/monitoring/MonitoringBySource"),
  "MonitoringBySource"
);
export const MonitoringByStep = lazyScreen(
  () => import("../screens/monitoring/MonitoringByStep"),
  "MonitoringByStep"
);
export const MonitoringByStop = lazyScreen(
  () => import("../screens/monitoring/MonitoringByStop"),
  "MonitoringByStop"
);
export const MonitoringByStopTable = lazyScreen(
  () => import("../screens/monitoring/MonitoringByStopTable"),
  "MonitoringByStopTable"
);
export const MonitoringCashDetails = lazyScreen(
  () => import("../screens/monitoring/MonitoringCashDetails"),
  "MonitoringCashDetails"
);
export const MonitoringCashRegister = lazyScreen(
  () => import("../screens/monitoring/MonitoringCashRegister"),
  "MonitoringCashRegister"
);
export const MonitoringCheckTable = lazyScreen(
  () => import("../screens/monitoring/MonitoringCheckTable"),
  "MonitoringCheckTable"
);
export const MonitoringDetails = lazyScreen(
  () => import("../screens/monitoring/MonitoringDetails"),
  "MonitoringDetails"
);
export const MonitoringLine = lazyScreen(
  () => import("../screens/monitoring/MonitoringLine"),
  "MonitoringLine"
);
export const MonitoringLoad = lazyScreen(
  () => import("../screens/monitoring/MonitoringLoad"),
  "MonitoringLoad"
);
export const MonitoringLosses = lazyScreen(
  () => import("../screens/monitoring/MonitoringLosses"),
  "MonitoringLosses"
);
export const MonitoringMainData = lazyScreen(
  () => import("../screens/monitoring/MonitoringMainData"),
  "MonitoringMainData"
);
export const MonitoringMap = lazyScreen(
  () => import("../screens/monitoring/MonitoringMap"),
  "MonitoringMap"
);
export const MonitoringNonPayers = lazyScreen(
  () => import("../screens/monitoring/MonitoringNonPayers"),
  "MonitoringNonPayers"
);
export const MonitoringSelect = lazyScreen(
  () => import("../screens/monitoring/MonitoringSelect"),
  "MonitoringSelect"
);

export const OrderDetails = lazyScreen(
  () => import("../screens/monitoringOrder"),
  "OrderDetails"
);
export const PdfView = lazyScreen(() => import("../screens/pdfView"), "PdfView");
export const PhoneCall = lazyScreen(() => import("../screens/phoneCall"), "PhoneCall");
export const PhoneCallCounts = lazyScreen(
  () => import("../screens/phoneCall"),
  "PhoneCallCounts"
);
export const PhotoReport = lazyScreen(() => import("../screens/photoReport"), "PhotoReport");
export const PhotoReportCreate = lazyScreen(
  () => import("../screens/photoReport"),
  "PhotoReportCreate"
);
export const PhotoReportList = lazyScreen(
  () => import("../screens/photoReport"),
  "PhotoReportList"
);
export const ProductCards = lazyScreen(
  () => import("../screens/products/ProductCards"),
  "ProductCards"
);
export const ProductDetails = lazyScreen(
  () => import("../screens/products/ProductDetails"),
  "ProductDetails"
);
export const Profile = lazyScreen(() => import("../screens/profile"), "Profile");
export const Purchase = lazyScreen(() => import("../screens/purchase"), "Purchase");
export const PurchaseCards = lazyScreen(() => import("../screens/purchase"), "PurchaseCards");
export const PurchaseDetails = lazyScreen(
  () => import("../screens/purchase"),
  "PurchaseDetails"
);
export const RegisterDocDetails = lazyScreen(
  () => import("../screens/purchase"),
  "RegisterDocDetails"
);
export const RegisterDocs = lazyScreen(() => import("../screens/purchase"), "RegisterDocs");
export const GallaryList = lazyScreen(() => import("../screens/quiz"), "GallaryList");
export const QuestionDetails = lazyScreen(() => import("../screens/quiz"), "QuestionDetails");
export const Quiz = lazyScreen(() => import("../screens/quiz"), "Quiz");
export const QuizEdit = lazyScreen(() => import("../screens/quiz"), "QuizEdit");
export const QuizesUser = lazyScreen(() => import("../screens/quiz"), "QuizesUser");
export const QuizList = lazyScreen(() => import("../screens/quiz"), "QuizList");
export const Report = lazyScreen(() => import("../screens/report"), "Report");
export const ViewReport = lazyScreen(() => import("../screens/report/ViewReport"), "ViewReport");
export const ReviewByObjects = lazyScreen(() => import("../screens/reviews"), "ReviewByObjects");
export const ReviewCommon = lazyScreen(() => import("../screens/reviews"), "ReviewCommon");
export const ReviewObjList = lazyScreen(() => import("../screens/reviews"), "ReviewObjList");
export const SelectEmployee = lazyScreen(
  () => import("../screens/selectEmployee"),
  "SelectEmployee"
);
export const SelectLocation = lazyScreen(
  () => import("../screens/selectLocation"),
  "SelectLocation"
);
export const SettingsScreen = lazyScreen(() => import("../screens/settings"), "SettingsScreen");
export const TableView = lazyScreen(() => import("../screens/tableView"), "TableView");
export const QuicklyTaskCreate = lazyScreen(
  () => import("../screens/taskCreate"),
  "QuicklyTaskCreate"
);
export const TaskCreate = lazyScreen(() => import("../screens/taskCreate"), "TaskCreate");
export const TaskList = lazyScreen(() => import("../screens/taskList"), "TaskList");
export const QuicklyTaskTypes = lazyScreen(
  () => import("../screens/taskTypes"),
  "QuicklyTaskTypes"
);
export const TaskMenu = lazyScreen(() => import("../screens/taskTypes"), "TaskMenu");
export const TestPage = lazyScreen(() => import("../screens/test"), "TestPage");
export const TimeConfirmation = lazyScreen(
  () => import("../screens/timeControl"),
  "TimeConfirmation"
);
export const TimeControl = lazyScreen(() => import("../screens/timeControl"), "TimeControl");
export const WorkShift = lazyScreen(() => import("../screens/timeControl"), "WorkShift");
export const WorkShiftEmployee = lazyScreen(
  () => import("../screens/timeControl"),
  "WorkShiftEmployee"
);

export const AnaliticAdmin = lazyScreen(
  () => import("../screens/videoStreams"),
  "AnaliticAdmin"
);
export const AnaliticCameras = lazyScreen(
  () => import("../screens/videoStreams"),
  "AnaliticCameras"
);
export const AnaliticMenu = lazyScreen(() => import("../screens/videoStreams"), "AnaliticMenu");
export const AnaliticQueue = lazyScreen(
  () => import("../screens/videoStreams"),
  "AnaliticQueue"
);
export const AnaliticSales = lazyScreen(
  () => import("../screens/videoStreams"),
  "AnaliticSales"
);
export const Archive = lazyScreen(() => import("../screens/videoStreams"), "Archive");
export const JournalActions = lazyScreen(
  () => import("../screens/videoStreams"),
  "JournalActions"
);
export const JournalDetails = lazyScreen(
  () => import("../screens/videoStreams"),
  "JournalDetails"
);
export const ObjectCameras = lazyScreen(
  () => import("../screens/videoStreams"),
  "ObjectCameras"
);
export const StreamDetails = lazyScreen(
  () => import("../screens/videoStreams"),
  "StreamDetails"
);
export const VideoStreams = lazyScreen(() => import("../screens/videoStreams"), "VideoStreams");
export const CashQueue = lazyScreen(
  () => import("../screens/videoStreams/CashQueue"),
  "CashQueue"
);
export const Waiters = lazyScreen(() => import("../screens/waiters"), "Waiters");
export const WaitersCards = lazyScreen(() => import("../screens/waiters"), "WaitersCards");
export const WaitersCheckDetails = lazyScreen(
  () => import("../screens/waiters"),
  "WaitersCheckDetails"
);
export const WaitersDetails = lazyScreen(() => import("../screens/waiters"), "WaitersDetails");
